import type { Component } from "vue";
import { DialogType } from "~/core/enums";

export default function getActionDialogLogic() {
  const showActionDialog = ref<boolean>(false);
  const dialogType = ref<DialogType>(DialogType.action);
  const title = ref<string>("Attention");
  const message = ref<string>("Unknown message");
  const actionFunction = ref<Function>(() => {});
  const isActionLoading = ref<boolean>(false);
  const actionText = ref<string>("OK");
  const iconName = ref<string>();
  function showActionDialogFunc(
    titleString: string,
    type: DialogType,
    dialogMessage: string,
    onAction: Function,
    btnText: string,
    icon?: string
  ): void {
    iconName.value = icon;
    title.value = titleString;
    dialogType.value = type;
    message.value = dialogMessage;
    actionFunction.value = onAction;
    actionText.value = btnText;
    showActionDialog.value = true;
  }

  function hideActionDialogFunc(): void {
    showActionDialog.value = false;
    isActionLoading.value = false;
  }

  function showMessageDialogFunc(
    dialogMessage: string,
    type: DialogType
  ): void {
    iconName.value = undefined;
    title.value = type;
    dialogType.value = type;
    message.value = dialogMessage;
    actionFunction.value = hideActionDialogFunc;
    actionText.value = "Ok";
    showActionDialog.value = true;
  }

  function setIsActionLoading(value: boolean) {
    isActionLoading.value = value;
  }

  return {
    showActionDialog,
    showActionDialogFunc,
    hideActionDialogFunc,
    showMessageDialogFunc,
    dialogType,
    title,
    actionText,
    message,
    actionFunction,
    iconName,
    isActionLoading,
    setIsActionLoading,
  };
}
